<div class="range" [class.clickable]="!unclickable"
     (click)="onClick()"
     *ngIf="(range | async) as range">
    <span title="{{range[1]}}">
        {{ range[0] }}
    </span>
</div>
